module.exports = "._box-size{height:60px;justify-content:center;align-items:center}#_sidenav{padding:0px;margin:0px}:focus{display:none}\n"